export default "__VITE_ASSET__DJPT6mVH__"